import { useMutation, useQuery } from '@tanstack/react-query';
import { GenericQueryOptions } from 'queries/events/types';
import { ATTRIBUTES_BY_ID } from 'config/endpoints';
import { get, patch } from 'utils/axios';
import { AttributesList, AttributeFormData } from './contract';

export const useAttributtesByIdQuery = (
  assetId?: string,
  queryOptions?: GenericQueryOptions<AttributesList>,
) =>
  useQuery(
    ['GET_ATTRIBUTTES', 'MONITORING_LOADING', assetId],
    async () => {
      const response = await get<AttributesList>(ATTRIBUTES_BY_ID(assetId))();
      return response;
    },

    { ...queryOptions },
  );

export const useAttributtesMutation = (
  assetId?: string,
  onError?: () => void,
  onSuccess?: () => void,
) =>
  useMutation(
    async (data: AttributeFormData) => {
      return await patch<AttributeFormData>(ATTRIBUTES_BY_ID(assetId), { payload: data });
    },
    {
      onSuccess,
      onError,
    },
  );
